import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now().toString())
    this.containerTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest("[data-nested-form-item]")
    if (!wrapper) return

    const destroyInput = wrapper.querySelector("input[name*='_destroy']")
    const idInput = wrapper.querySelector("input[name$='[id]']")

    if (idInput?.value) {
      if (destroyInput) destroyInput.value = "1"
      wrapper.hidden = true
    } else {
      wrapper.remove()
    }
  }
}
